import { render, staticRenderFns } from "./ApprovedPlatforms.vue?vue&type=template&id=5db5080f&"
import script from "./ApprovedPlatforms.vue?vue&type=script&lang=js&"
export * from "./ApprovedPlatforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports